import { QUESTION_TYPE } from "../constants/QUESTION_TYPE";

/**
 * 必須質問の回答を検証し、未入力の質問IDをキーとするエラーマップを返す
 * @param {Array|null|undefined} questions - 質問オブジェクトの配列
 * @param {Object|null|undefined} answers - 質問IDをキーとする回答オブジェクト
 * @returns {Object} エラーのある質問IDをキー、trueをバリューとするオブジェクト。questionsまたはanswersがない場合は空オブジェクト
 */
export const validateAnswers = (questions, answers) => {
  if (!questions || !answers) {
    return {};
  }
  return questions
    .filter((question) => question.require)
    .reduce((errors, question) => {
      const answer = answers[question.id];
      if (!answer) {
        errors[question.id] = true;
        return errors;
      }
      switch (question.type) {
        case QUESTION_TYPE.CHECKBOX:
          if (answer.length === 0) {
            errors[question.id] = true;
          }
          break;
        case QUESTION_TYPE.TEXT:
        case QUESTION_TYPE.TEXTAREA:
        case QUESTION_TYPE.SELECT:
        case QUESTION_TYPE.RADIO:
          if (answer.trim() === "") {
            errors[question.id] = true;
          }
          break;
      }
      return errors;
    }, {});
};
